import { useFormikContext } from 'formik'
import get from 'lodash.get'
import * as React from 'react'
import { Box } from 'rebass'
import { useContentAreasQuery } from 'epc-schema'
import { Content, Form, Indicators, Input } from 'ui'
import { IContentAreaDataShape } from './ContentAreaGroup'

interface IContentAreaGroupsRendererProps {
  disabled?: boolean
  name: string
}

export function ContentAreaGroupsRenderer<
  T
>(): React.FC<IContentAreaGroupsRendererProps> {
  const CheckBoxGroupField = Input.CheckBoxGroupRenderer<T>()
  const ContentAreaGroups: React.FC<IContentAreaGroupsRendererProps> = (
    props
  ) => {
    const { values } = useFormikContext<any>()
    interface IContentAreaMap {
      [key: string]: IContentAreaDataShape[]
    }
    const { loading, data } = useContentAreasQuery()
    const contentAreas =
      (get(data, 'response.contentAreas') as IContentAreaDataShape[]) || []
    const standards: IContentAreaMap = contentAreas.reduce(
      (p: IContentAreaMap, c) => {
        const existingVals = p[c.standard] ? p[c.standard] : []
        return {
          ...p,
          [c.standard]: [...existingVals, c],
        }
      },
      {}
    )
    const checkedValues = values[props.name]
    return (
      <React.Fragment>
        {loading ? (
          <Indicators.Spinner size={'lg'} />
        ) : (
          Object.keys(standards).map((standard) => {
            const groupValues = standards[standard]
              .map((c) => ({
                label: `${c.lowerLevel}${c.coreIdea ? `: ${c.coreIdea}` : ''}`,
                value: c.id,
              }))
              .sort((a, b) =>
                a.label > b.label ? 1 : a.label < b.label ? -1 : 0
              )
            const initiallyOpen =
              groupValues.filter((g) => checkedValues.includes(g.value))
                .length > 0
            return (
              <Form.Row key={`contentArea${standard}`}>
                <Form.Item width={1}>
                  <Content.Collapse
                    label={`${standard}`}
                    initiallyOpen={initiallyOpen}
                  >
                    <Box marginTop={1} marginBottom={2} width={1}>
                      <CheckBoxGroupField
                        disabled={props.disabled}
                        required={true}
                        inline={true}
                        inputWidth={1 / 2}
                        name={props.name}
                        values={groupValues}
                      />
                    </Box>
                  </Content.Collapse>
                </Form.Item>
              </Form.Row>
            )
          })
        )}
      </React.Fragment>
    )
  }
  return ContentAreaGroups
}
